import { render, staticRenderFns } from "./TradeContractViewPanel.vue?vue&type=template&id=5f0e1c50&scoped=true&"
import script from "./TradeContractViewPanel.vue?vue&type=script&lang=js&"
export * from "./TradeContractViewPanel.vue?vue&type=script&lang=js&"
import style0 from "./TradeContractViewPanel.vue?vue&type=style&index=0&id=5f0e1c50&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f0e1c50",
  null
  
)

export default component.exports